import { ArrowDropDownIcon, Button, Menu, MenuItem } from '@freighthub/silhouette-core'
import { useObserver } from 'mobx-react-lite'
import { FC, MouseEvent, useState } from 'react'
import { LanguageISO, useI18n } from 'utils/localisation'

export const LanguageSelect: FC = () => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClickButton = (event: MouseEvent<HTMLButtonElement>) => {
    // @ts-expect-error TS(2345) FIXME: Argument of type 'EventTarget & HTMLButtonElement'... Remove this comment to see the full error message
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const { availableLanguages, current, currentName, setLanguage } = useI18n()

  const handleClickLanguage = (language: LanguageISO) => {
    setLanguage(language)
    handleClose()
  }

  return useObserver(() => (
    <>
      <Button endIcon={<ArrowDropDownIcon />} onClick={handleClickButton}>
        {currentName}
      </Button>
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={handleClose}
        width="auto"
      >
        {availableLanguages.map((language) => (
          <MenuItem
            key={language.code}
            value={language.code}
            selected={current === language.code}
            onClick={() => handleClickLanguage(language.code)}
          >
            {language.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  ))
}
